import React from 'react';
import graph from '../graph';
import Create from '../Create';
import Update from '../Update';

import { useSelector } from 'react-redux';
import { hasRequiredRole } from 'helpers';
import { FormattedMessage } from 'react-intl';
import { AvatarPopover, NewMediaPopup } from 'components';
import {
  Fade,
  Card,
  Stack,
  Divider,
  Checkbox,
  IconButton,
  Typography,
  CardHeader,
  CardActions,
  CardActionArea,
} from '@mui/material';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

export default function Model({
  model,
  delay,
  checked,
  refetch,
  isAssign,
  selectable,
  handleSelect,
  showChildren,
  acception,
  selection,
  handleSelectAllClick,

  indeterminate,
}) {
  const { id, title, media, children } = model;

  const roles = ['superadmin', 'operator'];
  const { userInfo } = useSelector((state) => state.auth);
  const hasRole = hasRequiredRole(roles, userInfo?.roles);

  return (
    <>
      <Fade in unmountOnExit timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}>
        <Stack direction="row" alignItems="center">
          <Checkbox size="small" onChange={handleSelectAllClick} checked={checked} indeterminate={indeterminate} />
          <Card
            sx={{
              width: '100%',
              position: 'relative',
              borderColor: checked && 'primary.main',
              bgcolor: checked && 'action.disabledBackground',
            }}
            variant="outlined"
          >
            <CardHeader
              sx={{ p: 1 }}
              // avatar={
              //   <NewMediaPopup id={id} model="ProductCategory" collection="avatar" title={title} graph={graph}>
              //     <AvatarPopover isAssign={isAssign} sx={{ width: 48, height: 48 }} media={media[0]?.full_url} />
              //   </NewMediaPopup>
              // }
              title={
                <Stack rowGap={0.5} alignItems="flex-start">
                  <Typography variant="subtitle1">{title}</Typography>
                </Stack>
              }
              action={
                <IconButton
                  disabled
                  size="small"
                  sx={{ bgcolor: 'action.hover' }}
                  // onClick={() => showChildren(id)}
                >
                  <KeyboardArrowDownRoundedIcon fontSize="small" />
                </IconButton>
              }
            />
            <CardActions sx={{ justifyContent: 'flex-end' }}>
              {!hasRole && (
                <>
                  <Update ids={id} refetch={refetch} title={<FormattedMessage id="update" />} />
                  <Create ids={id} refetch={refetch} title={<FormattedMessage id="create" />} />
                </>
              )}
            </CardActions>
            <CardActionArea
              sx={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                position: 'absolute',
              }}
              disabled={!isAssign && !selectable}
              onClick={handleSelect}
            />
          </Card>
        </Stack>
      </Fade>
      {/* <Divider variant="middle" /> */}
    </>
  );
}
